export default __webpack_public_path__ + "static/gsheet-hero-img-2f1499bbbe7fd32b0fa686ccc79b992c.png";